import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./theme-noryx.css";
import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reduxSaga/reducers/index";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";

import rootSaga from "./reduxSaga/sagas/rootSagas";

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

const store = compose(
  applyMiddleware(...middleware)
)(createStore)(reducers);

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
